import * as Yup from 'yup';
import { PqrInfoWeb } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrInfoWeb = {
    channelPresentsFailure: '',
    country: '',
    location: '',
    detail: '',
    type: '',
    acceptTerms: false,
};

export const validationSchema = (isColombia?: boolean) =>
    Yup.object({
        channelPresentsFailure: Yup.string().required(
            'El canal qué presentó falla es obligatorio'
        ),
        type: Yup.string().required('La clasificación es obligatoria'),
        country: Yup.string().required('El país es obligatorio'),
        acceptTerms: Yup.boolean()
            .oneOf([true], 'Debes aceptar el tratamiento de datos personales')
            .required('Debes aceptar el tratamiento de datos personales'),
        location: Yup.string().when({
            is: () => Boolean(isColombia),
            then: (schema) =>
                schema.required('La ubicación PQR es obligatoria'),
        }),
        detail: Yup.string()
            .required('El detalle es obligatorio')
            .max(
                4294967295,
                'El detalle debe tener 4294967295 caracteres alfanuméricos como máximo'
            ),
    });
